module.exports = __webpack_public_path__ + "img/mr-prickles.808b00df.png";